import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import CustomToaster from '@components/CustomToaster';
import { AppContextProvider } from '@contexts/AppContext';

import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';
import MiddleSection from './MiddleSection';

const queryClient = new QueryClient();

const CorporateLanding = ({ env, isWebview }) => {
  return (
    <AppContextProvider env={env} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <CustomToaster />
        <HeaderSection />
        <MiddleSection />
        <FooterSection />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default CorporateLanding;
